class ProductFormComponent extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    if (!this.form) return;

    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
    this.cartDrawer = document.querySelector('cart-drawer');
    this.cartItems = document.querySelector('cart-items');

    this.isCartPage = !!document.body.classList.contains('template-cart');
  }

  onSubmitHandler(event, trigger = null) {
    if (event) event.preventDefault();

    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('button--loading');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    let sectionsToFetch = [];
    if (this.cartDrawer) {
      sectionsToFetch = [...sectionsToFetch, ...this.cartDrawer.getSectionsToRender().map(section => section.section)];
    }
    else if (this.isCartPage) {
      sectionsToFetch = [
        ...sectionsToFetch,
        ...this.cartItems.getCartSectionsToRender().map(section => section.section),
        ...this.cartItems.getCartRelatedSection().map(section => section.section),
      ];
    }
    if (this.cartNotification) {
      sectionsToFetch = [...sectionsToFetch, ...this.cartNotification.getSectionsToRender().map(section => section.section)];
    }

    let uniqueSectionsToFetch = [...new Set(sectionsToFetch)];

    // this needs refactoring based on the repeat variant we now know to be active (is_repeat_variant or is_not_repeat_variant) and then add multiple items to the cart based on the upsell products and add repeat variant with the form for the repeat product set in the settings
    const formData = new FormData(this.form);
    const id = formData.get('id');
    const quantity = formData.get('quantity');
    const variant_has_repeat = formData.get('repeat');
    const product = formData.get('product');
    const selling_plan = formData.get('selling_plan');
    const items = [
      {
        id,
        quantity,
        properties: {
          _hasRepeat: variant_has_repeat,
        },
      },
    ];

    // repeat abo product
    if (variant_has_repeat === 'true') {
      items[0].properties._repeatProduct = id;
      items.push({
        id: window.repeatProduct.repeat,
        quantity,
        selling_plan: window.repeatProduct.repeat_selling_plan,
        parent_id: id,
        properties: {
          _repeatProduct: id,
          _repeatProductTitle: product,
        },
      });
      if (selling_plan) {
        items[1].selling_plan = window.repeatProduct.repeat_selling_plan;
      }
    }
    else if (selling_plan) {
      items[0].selling_plan = selling_plan;
    }

    // Upsell products that are added along with the main product
    const upsellInputs = this.form.querySelectorAll('input.product-form__upsell-input:checked');
    upsellInputs.forEach(input => {
      const variantId = input.value ? parseInt(input.value, 10) : 0;
      if (variantId) {
        items.push({
          id: variantId,
          quantity: 1,
        });
      }
    });

    const body = JSON.stringify({
      ...{ items },
      sections: uniqueSectionsToFetch,
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(),
      ...{ body } })
      .then(response => response.json())
      .then(parsedState => {
        if (parsedState.status == 422) {
          // Render the cart drawer items again because even if there was a quantity error, items could still have been added
          this.cartDrawer?.renderCartDrawer();
          return;
        }

        if (this.cartDrawer) {
          this.cartDrawer.renderContents(parsedState);
        }
        else {
          // on the cart page
          this.cartItems.updateContent(parsedState, null, null, true);
        }

        window.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: parsedState }));

        switch (submitButton.dataset.addToCartBehavior) {
        case 'open_cart_drawer':
          // Set timeout to force animation. Because content is just updated with renderContents
          setTimeout(() => {
            this.cartDrawer?.open(trigger);
          }, 100);
          break;
        case 'show_cart_notification':
          if (!this.isCartPage && !document.body.classList.contains('cart-drawer-is-open')) {
            this.cartNotification?.renderContents(parsedState, submitButton);
          }
          break;
        default:
          this.cartNotification?.renderContents(parsedState, submitButton);
        }
      })
      .catch(error => {
        debug() && console.error(error);
      })
      .finally(() => {
        submitButton.classList.remove('button--loading');
        submitButton.removeAttribute('disabled');

        if (this.closest('#addToCartModal')) {
          document.body.classList.remove('show-add-to-cart-modal');
          removePreventScroll();
        }
      });
  }
}

if (!customElements.get('product-form-component')) {
  customElements.define('product-form-component', ProductFormComponent);
}
